/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Parts_TitleInputs */

const en_mk_parts_title = /** @type {(inputs: Mk_Parts_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Four parts, one workspace`)
};

const id_mk_parts_title = /** @type {(inputs: Mk_Parts_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empat bagian, satu ruang kerja`)
};

/**
* | output |
* | --- |
* | "Four parts, one workspace" |
*
* @param {Mk_Parts_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_parts_title = /** @type {((inputs?: Mk_Parts_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Parts_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_parts_title(inputs)
	return en_mk_parts_title(inputs)
});